import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Calibration_Interface, Empty_Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { Lab_Interface } from 'src/app/Interface/Lab_Interface';
import { Listener } from 'selenium-webdriver';
import { General_Interface } from 'src/app/Interface/General_Interface';

@Injectable({
  providedIn: 'root'
})
export class LabService {

  constructor(private http: HttpClient) { }

  Get(StartDate_ReceiveDate: String,
    EndDate_ReceiveDate: String,

    StartDate_DownloadDate: String,
    EndDate_DownloadDate: String,

    StartDate_UploadDate: String,
    EndDate_UploadDate: String,

    SubmitPeriodDate_ReceiveDate: number,
    SubmitPeriodDate_DownloadDate: number,
    SubmitPeriodDate_UploadDate: number,

    Customer: String,
    Type_Lap: number
  ): Observable<Array<Lab_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab?StartDate_ReceiveDate=" + StartDate_ReceiveDate
      + "&EndDate_ReceiveDate=" + EndDate_ReceiveDate

      + "&StartDate_DownloadDate=" + StartDate_DownloadDate
      + "&EndDate_DownloadDate=" + EndDate_DownloadDate

      + "&StartDate_UploadDate=" + StartDate_UploadDate
      + "&EndDate_UploadDate=" + EndDate_UploadDate

      + "&SubmitPeriodDate_ReceiveDate=" + SubmitPeriodDate_ReceiveDate
      + "&SubmitPeriodDate_DownloadDate=" + SubmitPeriodDate_DownloadDate
      + "&SubmitPeriodDate_UploadDate=" + SubmitPeriodDate_UploadDate


      + "&Type_Lap=" + Type_Lap
      + "&CustomerName=" + Customer
    ).pipe(
      map(data => {
        return data as Array<Lab_Interface>
      })
    )
  }

  GetLabCalibration(): Observable<Array<Lab_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab/GetLabCalibration").pipe(
        map(data => {
          return data as Array<Lab_Interface>
        })
      )
  }

  GetDetailDownloadCount(): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab/GetDetailDownloadCount").pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }

  GetLabConfirmCalibration(): Observable<Array<Lab_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab/GetLabConfirmCalibration").pipe(
        map(data => {
          return data as Array<Lab_Interface>
        })
      )
  }

  GetLabCertificate(): Observable<Array<Lab_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab/GetLabCertificate").pipe(
        map(data => {
          return data as Array<Lab_Interface>
        })
      )
  }

  GetDetailCount(): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab/GetDetailCount").pipe(
        map(data => {
          return data as any
        })
      )
  }

  PostDownload(code: Array<string>, id: number): Observable<Array<General_Interface>> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id: id,
      code: code,
    }

    return this.http.post(environment.BaseUrl + "Daro/Lab/PostDownload", body, { headers }).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )

  }

  PostDownloadHamKar(code: Array<string>,
    userDsc: Array<string>,
    id: number,
    Subject_id: number,
    Customer_id: number): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id: id,
      Customer_id: Customer_id,
      Subject_id: Subject_id,
      code: code,
      userDsc: userDsc,
    }

    return this.http.post(environment.BaseUrl + "Daro/Lab/PostDownloadHamKar", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  GetRequestExit(): Observable<Array<Calibration_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab/GetRequestExit").pipe(
        map(data => {
          return data as Array<Calibration_Interface>
        })
      )
  }


  AnswerReviewExit(id: number,status: number, dsc: String): Observable<any> {

    return this.http.get(environment.BaseUrl + "Daro/Lab/AnswerReviewExit?id=" + id
      + "&status=" + status
      + "&dsc=" + dsc
      ).pipe(
      map(data => {
        return data as any
      })
    )

  }

  PostUpload(code: Array<string>): Observable<Array<General_Interface>> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      Token: '',
      code: code,
    }


    return this.http.post(environment.BaseUrl + "Daro/Lab/PostUpload", body, { headers }).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )

  }

  PostExit(code: String, dsc: String): Observable<Calibration_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {}


    return this.http.post(environment.BaseUrl + "Daro/Lab/PostExit?Code=" + code + "&dsc=" + dsc, body, { headers }).pipe(
      map(data => {
        return data as Calibration_Interface
      })
    )

  }

  SubmitCalibrationDate(id: number, dsc: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {}


    return this.http.post(environment.BaseUrl + "Daro/Lab/SubmitCalibrationDate?id=" + id
      + "&dsc=" + dsc
      , body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  SubmitExpertCalibrationDate(id: number): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {}


    return this.http.post(environment.BaseUrl + "Daro/Lab/SubmitExpertCalibrationDate?id=" + id
      , body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }


  RequestExit(id: number,dsc: String): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Lab/RequestExit?id="+id+"&dsc="+dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }


}
